import { render, staticRenderFns } from "./AdditionalInformationTab.vue?vue&type=template&id=7bb8f505"
import script from "./AdditionalInformationTab.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationTab.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationTab.vue?vue&type=style&index=0&id=7bb8f505&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports